<template>
    <div class="pt-[20px] bg-[#ededed]">
        <div class="max-w-[1400px] w-full container mx-auto">
            <div class="pt-[60px] pr-[20px] pb-[2%] pl-[10px] max-w-[1400px]" id="mediaNavigation">
                <mediaNavigation />
            </div>
        </div>
    </div>
    <div class="max-w-[1400px] w-full container mx-auto">
        <v-breadcrumbs :items="breadcrumbs"></v-breadcrumbs>
        <div class="pt-[30px] pr-[20px] pb-[40px] pl-[10px] max-w-[1400px]" id="mediaContent">
            <router-view />
        </div>
    </div>
</template>

<script lang="ts" setup>
    import { computed } from 'vue'
    import { useRoute } from 'vue-router'
    import mediaNavigation from '@/components/SubNavigations/TheMediaNavigation.vue'

    const route = useRoute()

    // Generate breadcrumbs based on current route
    const breadcrumbs = computed(() => {
        const items = [
            {
                title: 'Media',
                disabled: false,
                href: '/media',
            },
        ]

        // Add video player breadcrumb if on player route
        if (route.name === 'VideoPlayer') {
            items.push({
                title: 'Video Player',
                disabled: route.params.id ? false : true,
                href: '/media/player',
            })

            // Add video ID breadcrumb if available
            if (route.params.id) {
                items.push({
                    title: `Video ${route.params.id}`,
                    disabled: true,
                    href: `/media/player/${route.params.id}`,
                })
            }
        }

        return items
    })
</script>
